import { cn } from '@/lib/utils'

/**
 * Property chips in the global create dialog (design 29a). Every chip carries
 * its label; a set chip is solid, an unset one is a ghost so the set ones
 * stand out.
 */
export function createChipClass(isSet: boolean, className?: string) {
  return cn(
    'inline-flex h-7 w-auto min-w-0 flex-none items-center justify-start gap-1.5 rounded-[7px] border px-2.5 text-[12.5px] font-normal shadow-none transition-colors focus:ring-0 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring',
    isSet
      ? 'border-input bg-card text-foreground hover:bg-accent'
      : 'border-border bg-transparent text-muted-foreground hover:bg-accent hover:text-foreground',
    className,
  )
}
